module.exports = { apiServer: 'https://api.uat.in-store.hk', AdminServer: 'https://Admin.Eventizer.hk', env: 'prod' };
